// R11-2 — THE DEEP ASTROLOGY READING'S VIEW, AND THE UNIT ITS SCORE IS PRINTED IN.
//
// Tenth shell out of App.tsx, moved so `ReportBody` — the dispatcher that names it — could follow.
// It takes props, holds no state and calls no hook, so scripts/r11-dispatch.mjs CALLS it and reads
// the returned tree: the two scores are different measurements and the view has to say which one it
// is printing. Moved VERBATIM; the narrative shell it wraps was already out (R9-1).

import { NarrativeReportView, type NarrativeReportData } from "./NarrativeReportView";

export type DeepReportData = NarrativeReportData & {
  subjects?: string[] | null;
  score?: number | null;
  scoreUnit?: "percent" | "discepolo" | null;
  scoreLabel?: string | null;
  dynamics?: { harmony: number; tension: number } | null;
  passes?: { pass: number; date: string; motion: string }[] | null;
};


// A deep astrology reading. The score is rendered by its UNIT, because the two
// two-subject readings use different scales that mean different things: synastry's is a
// compatibility percentage, while the Discepolo score is raw points measuring how much
// the bond WEIGHS (a high one can be a hard love). Never show the second as a percentage.
export function DeepReportView({ data }: { data: DeepReportData }) {
  const hasScore = typeof data.score === "number";
  // R11-2: `data.dynamics` was drawn INSIDE this block but was not one of the conditions that opened
  // it, and the two are independent on the server — the score comes from `overall_compatibility_score`
  // / `score` and the split from `dynamics.harmony_percentage`, so a vendor payload carrying the
  // percentages and no overall score threw the whole split away in silence. The inverse of R9's law:
  // there a labelled field was printed over nothing, here something real was computed and not printed.
  return (
    <NarrativeReportView
      data={data}
      extras={hasScore || data.dynamics || data.passes?.length ? (
        <section className="acg-evidence">
          {hasScore ? (
            <div className="deep-report__score">
              <span>{data.scoreUnit === "percent" ? "Compatibility" : "Significance (Discepolo)"}</span>
              <strong>{data.score}{data.scoreUnit === "percent" ? "%" : " pts"}</strong>
              {data.scoreLabel ? <em>{data.scoreLabel}</em> : null}
              {data.scoreUnit === "discepolo" ? (
                <p className="deep-report__score-note">This measures how much the bond weighs, not how happy it is.</p>
              ) : null}
            </div>
          ) : null}
          {data.dynamics ? (
            <p className="deep-report__split">{data.dynamics.harmony}% harmony · {data.dynamics.tension}% tension</p>
          ) : null}
          {data.passes?.length ? (
            <>
              <h3>The exact passes</h3>
              <ul>
                {data.passes.map((p) => <li key={p.pass}>Pass {p.pass}: <strong>{p.date}</strong> ({p.motion})</li>)}
              </ul>
            </>
          ) : null}
        </section>
      ) : undefined}
    />
  );
}
